import { styled } from '@mui/material';

import { Container as ErrorStepBottomBarContainer } from './ErrorStepBottomBar.styles';

export const Container = styled(ErrorStepBottomBarContainer)`
  background-color: ${({ theme }) => theme.palette.success.main};
`;
